module.exports = __webpack_public_path__ + "img/logo.f19e4775.png";